import { useEffect, useState, useMemo } from "react";
import { fetchStopsFromMap } from "../api/initialStops";
import { Stop } from "../types";
import { ignoreAbort } from "../utils/errors";

export type Grid = {
  minLat: number;
  maxLat: number;
  minLng: number;
  maxLng: number;
  step: number;
};

const defaultGrid: Grid = {
  minLat: 56,
  maxLat: 59,
  minLng: 13,
  maxLng: 18,
  step: 5,
};

export function useStops(grid: Grid = defaultGrid) {
  const [stops, setStops] = useState<Stop[]>([]);
  useEffect(() => {
    let alive = true;
    const boxes: google.maps.LatLngBoundsLiteral[] = [];
    for (let lat = grid.minLat; lat < grid.maxLat; lat += grid.step) {
      for (let lng = grid.minLng; lng < grid.maxLng; lng += grid.step) {
        boxes.push({
          north: lat + grid.step,
          south: lat,
          east: lng + grid.step,
          west: lng,
        });
      }
    }
    (async () => {
      const results = await Promise.all(
        boxes.map((b) => fetchStopsFromMap(b, false).catch(ignoreAbort))
      );
      if (!alive) return;
      const uniq = new Map<string, Stop>();
      for (const arr of results) {
        (arr ?? []).forEach((s: any) => {
          uniq.set(s.id, s);
        });
      }
      setStops(Array.from(uniq.values()));
    })();
    return () => {
      alive = false;
    };
  }, [grid.minLat, grid.maxLat, grid.minLng, grid.maxLng, grid.step]);

  const byId = useMemo(() => new Map(stops.map((s) => [s.id, s])), [stops]);
  return { stops, byId };
}
